import { blub, data_presentation, data_chart, selfServerTool } from '../assets/images';

export const content = [
  {
    text: 'Real-time analytics through an easy-to-understand dashboard',
    image: data_chart,
  },
  {
    text: 'Data sense to identify risks at your organization & plan interventions to improve overall well-being',
    image: data_presentation,
  },
  {
    text: 'Meaningful insights to optimize your healthcare spend',
    image: blub,
  },
  {
    text: 'Self-Serve tool to be in control of your requirements',
    image: selfServerTool
  }
];

export const metric_content = [
  { heading: '500K+', body: 'employees and their families served' },
  { heading: '100M', body: 'saved on health checks' },
  { heading: '440K', body: 'hours saved using online doctor consultation' },
];

export const reset_password_checks = [
  '8 characters minimum',
  'Atleast one uppercase letter',
  'Atleast one lowercase letter',
  'Atleast one number',
]

const employeeData = {
  email : '',
  passowrd : ''
}